import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconDevtoolsOutline } from '@saucelabs/ds-icons';

import { MANUAL_TEST_EVENTS, trackEvent } from '../../../tracking';
import {
  actions as developerDrawerActions,
  selectors as developerDrawerSelectors,
} from '../../developerDrawer';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const DeveloperOptionsButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    device,
    deviceToolsDisabled,
  } = useSelector(selectors.toolbarButtonSelector);
  const { isOpen } = useSelector(developerDrawerSelectors.developerDrawerSelector);

  const toggleDeveloperDrawer = () => {
    void dispatch(developerDrawerActions.setDeveloperDrawerOpen(!isOpen));
    device?.resize();

    trackEvent(isOpen ?
      MANUAL_TEST_EVENTS.HIDE_DEVELOPER_OPTIONS :
      MANUAL_TEST_EVENTS.SHOW_DEVELOPER_OPTIONS,
    );
  };

  return (
    <GenericButton
      dataQa="live-session-toolbar-button-developer-options"
      disabled={deviceToolsDisabled}
      icon={IconDevtoolsOutline}
      label="Developer Options"
      onPress={toggleDeveloperDrawer}
      role={role}
    />
  );
};

DeveloperOptionsButton.displayName = 'DeveloperOptionsButton';

export default DeveloperOptionsButton;
